import React, { useEffect, useRef, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { toCurrency, toThousands } from "../utils/Convert";
import { Button, Flex, Tag, Typography, Modal } from "antd";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import dayjs from "dayjs";
import { FileDoneOutlined } from "@ant-design/icons";
import PaymentJob from "../job/PaymentJob";

const { Text } = Typography;

const ClientSummary = ({ match, history }) => {
	const clientID = match.params.id;
	const [customerName, setCustomerName] = useState("");
	const [address, setAddress] = useState("");
	const [credit, setCredit] = useState(false);
	const [loading, setLoading] = useState(false);
	const [jobs, setJobs] = useState([]);
	const [invoices, setInvoices] = useState([]);
	const [jobNumber, setJobNumber] = useState(0);
	const [totalTarget, setTotalTarget] = useState(0);
	const [totalLoad, setTotalLoad] = useState(0);
	const [sumSub, setSumSub] = useState(0);
	const [sumTax, setSumTax] = useState(0);
	const [sumTotal, setSumTotal] = useState(0);
	const [customerPhone, setCustomerPhone] = useState("Not defined");
	const [term, setTerm] = useState("");
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [client, setClient] = useState({});
	const [jobLoading, setJobLoading] = useState(true);
	const [invoiceLoading, setInvoiceLoading] = useState(true);
	const jobId = useRef(null);
	const [modalInvoiceOpen, setModalInvoiceOpen] = useState(false);
	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Job ID",
			dataIndex: "number",
			key: "number",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Shipping Address",
			dataIndex: "address",
			key: "address",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Load YD3",
			dataIndex: "loadYD3",
			key: "loadYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Target YD3",
			dataIndex: "targetYD3",
			key: "targetYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Status",
			dataIndex: "jobStatus",
			key: "jobStatus",
			render: (value) => {
				let color = "default";
				let label = value;
				switch (value) {
					case "ok":
						color = "blue";
						label = "Poured";
						break;
					case "Confirm":
						color = "green";
						label = "A/R Confirmed";
						break;
					case "Active":
						color = "cyan";
						label = "Pouring";
						break;
					case "Operations done (AR)":
						color = "purple";
						break;
					case "Scheduled":
						color = "red";
						break;
					default:
						color = "default";
				}

				return <Tag color={color}>{label}</Tag>;
			},
		},
		{
			title: "",
			dataIndex: "edit",
			width: 200,
			render: (_, record) => {
				return (
					<Flex justify="space-between">
						{record.jobStatus === "Operations done (AR)" && (
							<Button
								type="primary"
								icon={<FileDoneOutlined twoToneColor={"white"} />}
								onClick={(e) => history.push(`/jobtoinvoice/${record.id}`)}
							>
								Summary
							</Button>
						)}
					</Flex>
				);
			},
		},
	];
	const columns2 = [
		{
			title: "Invoice ID",
			dataIndex: "invoiceNumber",
			key: "invoiceNumber",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "PSI",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total Yards",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Subtotal",
			dataIndex: "subtotal",
			key: "subtotal",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Tax",
			dataIndex: "tax",
			key: "tax",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total",
			dataIndex: "total",
			key: "total",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Balance",
			dataIndex: "balance",
			key: "balance",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},

		{
			title: "Action",
			dataIndex: "action",
			width: 200,
			render: (_, record) => {
				return (
					<Flex justify="space-between">
						<Button
							type="primary"
							icon={<FileDoneOutlined twoToneColor={"white"} />}
							onClick={() => {
								jobId.current = record.job;
								setModalInvoiceOpen(true);
							}}
						>
							Apply
						</Button>
					</Flex>
				);
			},
		},
		{
			title: "Payments",
			dataIndex: "payments",
			key: "payments",
			render: (value) => {
				if (value.length === 0) {
					return <Text>No Payments</Text>;
				}
				return (
					<Flex vertical>
						{value.map((pay, index) => {
							return (
								<Text key={index}>{`${pay.type}: ${toCurrency(
									pay.amount,
									2
								)}`}</Text>
							);
						})}
					</Flex>
				);
			},
		},
	];

	useEffect(() => {
		getClientInfo();
	}, []);

	useEffect(() => {
		getJobs();
		getInvoice();
	}, [startDate, endDate, term]);

	const getClientInfo = async () => {
		const url = api + `/customer/${clientID}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoading(true);
			const { data } = await axios.get(url);
			setClient(data);
			setCustomerName(`${data.customerNumber} ${data.name}`);
			setAddress(`${data.address}`);

			if (data.contactPhone) {
				setCustomerPhone(data.contactPhone);
			}

			data.paymentType === "Credit" ? setCredit(true) : setCredit(false);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getJobs = async () => {
		try {
			setJobLoading(true);
			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const url =
				api +
				`/joblist/search?customerId=${clientID}&startDate=${start}&endDate=${end}&term=${term}`;
			const { data } = await axios.get(url);
			const dataList = [];
			let totLoad = 0;
			let totTarget = 0;
			data.forEach((job, index) => {
				dataList.push({
					key: job._id,
					index: index,
					id: job._id,
					number: job.number,
					address: job.customerShipAddress || job.shipAddress,
					seller: job.seller.name,
					loadYD3: job.loadYD3,
					targetYD3: job.targetYD3,
					jobStatus: job.jobStatus,
					date: dayjs(job.scheduledDate).format("MM/DD/YYYY"),
				});
				totLoad += job.loadYD3;
				totTarget +=
					typeof job.targetYD3 === "string"
						? parseFloat(job.targetYD3)
						: job.targetYD3;
			});

			setTotalLoad(totLoad);
			setTotalTarget(totTarget);
			setJobs(dataList);
			setJobNumber(dataList.length);
			setJobLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getInvoice = async () => {
		try {
			setInvoiceLoading(true);
			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const url =
				api +
				`/customerinvoice/search?customerId=${clientID}&startDate=${start}&endDate=${end}&term=${term}`;
			const { data } = await axios.get(url);
			const dataList = [];
			let sTax = 0;
			let sSub = 0;
			let sTotal = 0;
			data.forEach((inv, index) => {
				dataList.push({
					psi: inv.psi,
					totalYards: inv.quantity,
					subtotal: toCurrency(inv.amount, 2),
					tax: toCurrency(inv.taxAmount, 2),
					total: toCurrency(inv.invoiceTotal, 2),
					date: dayjs(inv.invoiceDate).format("MM/DD/YYYY"),
					invoiceNumber: inv.invoiceNumber,
					id: inv._id,
					key: inv._id,
					index: index,
					payments: inv.payments,
					job: inv.job._id,
					balance: inv.balance ? toCurrency(inv.balance, 2) : "-",
				});

				sTax += inv.taxAmount ? parseInt(inv.taxAmount) : 0;
				sSub += inv.amount ? parseInt(inv.amount) : 0;
				sTotal += inv.invoiceTotal ? parseInt(inv.invoiceTotal) : 0;
			});

			setInvoices(dataList);
			setSumTax(sTax);
			setSumSub(sSub);
			setSumTotal(sTotal);
			setInvoiceLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const Head = () => (
		<div className="jumbotron jumbotron-fluid">
			<h3 className="display-4">{customerName}</h3>
			<p className="lead">{`${address}, ph: ${customerPhone} `}</p>
			<p className="lead">
				<b>CREDIT LIMIT:</b>{" "}
				{client.creditAmount
					? toCurrency(client.creditAmount, 2)
					: toCurrency(0, 2)}
				,<b>CREDIT USED:</b>{" "}
				{client.creditAmount
					? toCurrency(client.creditUsed, 2)
					: toCurrency(0, 2)}
				,<b>BALANCE:</b>{" "}
				{client.creditAmount ? toCurrency(client.balance, 2) : toCurrency(0, 2)}
			</p>
			<table>
				<tr>
					<td>{credit && <FontAwesomeIcon icon={faCheckSquare} />}</td>
					<td>Credit</td>
				</tr>
			</table>

			{/* <Button
				type="primary"
				size="large"
				onClick={() => history.push(`/generalpayment/${client._id}`)}
			>
				General Payment
			</Button> */}
		</div>
	);

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onSearch = (value, _e, info) => {
		if (info?.source === "input") {
			setTerm(value);
		}
	};

	const RenderSearch = () => {
		return (
			<CustomSearch
				onSearch={onSearch}
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				onRangeChange={onRangeChange}
				dateFormat={"MM/DD/YYYY"}
			/>
		);
	};

	const RenderJobTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<div className="d-flex justify-content-start">
					<h4>
						{`Jobs: ${jobNumber}, 
                            Load YD3: ${toThousands(totalLoad)}, 
                            Target YD3: ${toThousands(totalTarget)}`}
					</h4>
				</div>
				<CustomTable
					columns={columns}
					data={jobs}
					isScroll={true}
					loading={jobLoading}
				/>
			</Flex>
		);
	};

	const RenderInvoiceTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<div className="d-flex justify-content-start">
					<h4>
						{`Invoices: ${invoices.length}, 
                            Subtotal: ${toCurrency(sumSub)}, 
                            Taxes: ${toCurrency(sumTax)}, 
                            Total: ${toCurrency(sumTotal)}`}
					</h4>
				</div>
				<CustomTable
					columns={columns2}
					data={invoices}
					isScroll={true}
					loading={invoiceLoading}
				/>
			</Flex>
		);
	};

	const paymentsUpdated = () => {
		getInvoice();
		setModalInvoiceOpen(false);
		jobId.current = null;
	};

	const RenderModalInvoice = () => {
		return (
			<Modal
				title="Invoice Payments"
				open={modalInvoiceOpen}
				onCancel={() => setModalInvoiceOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
			>
				<PaymentJob jobId={jobId.current} pcb={paymentsUpdated} />
			</Modal>
		);
	};

	return (
		<Layout title="Client Summary" description="">
			<Flex gap={"middle"} vertical>
				{loading ? (
					<CustomSpinner />
				) : (
					<div>
						<Head />
						<br />
						<RenderSearch />
						<br />
						<RenderInvoiceTable />
						<br />
						<RenderJobTable />
					</div>
				)}
				<RenderModalInvoice />
			</Flex>
		</Layout>
	);
};

export default ClientSummary;
